export const getCurrentRelayIntervals = (state) => state.currentRelayInterval
export const getRelayIntervals = (state) => state.relay_intervals
